import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { danhSachHoanTotNghiepApi } from "../../../api/xet-tot-nghiep/danhSachHoanTotNghiepApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eDanhSachHoanTotNghiepActionIds, IDanhSachHoanTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDanhSachHoanTotNghiepActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.xetTotNghiep.danhSachHoanTotNghiep;

export function* danhSachHoanTotNghiepSaga(): any {
    yield takeLatest(eDanhSachHoanTotNghiepActionIds.LOAD_DA_THEM_START, loadDaThemWorker);
    yield takeLatest(eDanhSachHoanTotNghiepActionIds.LOAD_CHUA_THEM_START, loadChuaThemWorker);
    yield takeEvery(eDanhSachHoanTotNghiepActionIds.ADD_START, addWorker);
    yield takeEvery(eDanhSachHoanTotNghiepActionIds.DELETE_START, deleteWorker);
}

function* loadDaThemWorker(action: IDanhSachHoanTotNghiepActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(danhSachHoanTotNghiepApi.GetDaThem, id);
    if (res.is_success) {
        yield put(mainAction.LOAD_DA_THEM_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_DA_THEM_ERROR(res.message ?? "Lỗi khi tải danh sách hoãn tốt nghiệp"));
    }
}

function* loadChuaThemWorker(action: IDanhSachHoanTotNghiepActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(danhSachHoanTotNghiepApi.GetChuaThem, id);
    if (res.is_success) {
        yield put(mainAction.LOAD_CHUA_THEM_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_CHUA_THEM_ERROR(res.message ?? "Lỗi khi tải danh sách sinh viên có thể thêm"));
    }
}

function* addWorker(action: IDanhSachHoanTotNghiepActionTypes): any {
    const payload = action.payload as { id_xet_tot_nghiep: number, id_svs: string[], ly_do?: string };
    let ok = true;
    let message = "";
    for (const id_sv of payload.id_svs) {
        const res: IBaseResponse = yield call(danhSachHoanTotNghiepApi.Insert, {
            id_sv,
            ly_do: payload.ly_do ?? "",
            id_xet_tot_nghiep: payload.id_xet_tot_nghiep,
        });
        if (!res.is_success) {
            ok = false;
            message = res.message ?? "Lỗi khi thêm sinh viên hoãn tốt nghiệp";
        }
    }
    if (ok) {
        yield put(mainAction.ADD_SUCCESS(undefined));
    } else {
        yield put(mainAction.ADD_ERROR(message));
    }
    yield put(mainAction.LOAD_DA_THEM_START(payload.id_xet_tot_nghiep));
    yield put(mainAction.LOAD_CHUA_THEM_START(payload.id_xet_tot_nghiep));
}

function* deleteWorker(action: IDanhSachHoanTotNghiepActionTypes): any {
    const payload = action.payload as { id_xet_tot_nghiep: number, ids: number[] };
    let ok = true;
    let message = "";
    for (const id of payload.ids) {
        const res: IBaseResponse = yield call(danhSachHoanTotNghiepApi.Delete, id);
        if (!res.is_success) {
            ok = false;
            message = res.message ?? "Lỗi khi gỡ sinh viên hoãn tốt nghiệp";
        }
    }
    if (ok) {
        yield put(mainAction.DELETE_SUCCESS(undefined));
    } else {
        yield put(mainAction.DELETE_ERROR(message));
    }
    yield put(mainAction.LOAD_DA_THEM_START(payload.id_xet_tot_nghiep));
    yield put(mainAction.LOAD_CHUA_THEM_START(payload.id_xet_tot_nghiep));
}
